import has from 'mout/object/has'
import keys from 'mout/object/keys'
import queryString from 'query-string'
import { db } from '../../../config/firebaseconfig'
import initializeNewUserAssessment from '../initializeNewUserAssessment';
import getSchoolYear from '../../../helpers/getSchoolYear'

export default function initializeAssessment (
  assessmentId, 
  studentId, 
  districts, 
  user,
  search, 
  {loading, success, error},
  history,
  getGroupUA,
  schoolYear,
  initTestSelector
) {
  const userId = user.id
  const role = user.role

  //if user has selected previous school year data, then we set the schoolYear here
  //else it is set to current school year
  console.log(schoolYear)
  if(!schoolYear) {
    schoolYear = getSchoolYear().year;
  }
  // When role is admin, the selected student id is indicated
  // by "s" in the query (if there is a selected student).
  // There is only a selected student if the user has drilled down
  // from the class level all the way down to the student level
  // in the selector box.
  let selectedStudent = ''
  if (search) {
    const qs = queryString.parse(search)
    if (has(qs, 's')) {
      selectedStudent = qs.s
    }
  }
  
  // Does this if we are looking at an individual student's data.
  // We know this if the user role is "Student", if the user role
  // is an educator and there is a selectedStudent in the query, 
  // or if studentId was passed into this function.
  if (role === 'Student' || selectedStudent || studentId) {
    loading()
    let docId = userId
    if (selectedStudent || studentId) {
      docId = selectedStudent || studentId 
    }

    console.log(docId, schoolYear);
    return db.collection('students').doc(docId).get()
      .then((userDoc) => {
        const user = userDoc.data()

        // if this assessment exists in the user's record, fetch the corresponding
        // userAssessment. (This userAssessment stores all of the data about a 
        // specific user's interactions with one assessment.) 
        if (user.assessments[assessmentId]) {
            const userAssessmentId = user.assessments[assessmentId];

            if(userAssessmentId.hasOwnProperty(schoolYear)) {

              const userAssessmentId = user.assessments[assessmentId][schoolYear].userAssessmentId;
              db.collection('userAssessments').doc(userAssessmentId).get()
              .then((userAssessmentDoc) => {
                const userAssessment = userAssessmentDoc.data()
                success(userAssessment)
              })
              .catch((err) => error(err))
            }
        }
        //If this assessment does not exist in the user's record, initialize an
        //empty userAssessment for this user corresponding to this assessment.
        if(schoolYear) {
        if (!user.assessments || !has(user, `assessments.${assessmentId}`) || !user.assessments[assessmentId][schoolYear]) {
          let sets = {}
          let items = {}
          // Fetch all sets. Sets are groups of items and sets that are used to
          // as assessments or parts of assessments.
          const getSets = db.collection('sets').get()
            .then((querySnapshot) => {
              querySnapshot.forEach((setDoc) => {
                const setDocData = setDoc.data()
                sets[setDocData.id] = setDocData
              })
            })
            .catch((err) => error(err))

          // Fetch all content items. Each assessment question is one contentItem.
          const getItems = db.collection('contentItems').get()
            .then((querySnapshot) => {
              querySnapshot.forEach((contentItem) => {
                const contentItemData = contentItem.data()
                items[contentItemData.itemId] = contentItemData
              })
            })
            .catch((err) => error(err))

          Promise.all([getSets, getItems])
            .then(() => {
              // If the assessment does not exist as a set, then give "Not Found" error
              if (!sets[assessmentId]) {
                error('set not found')
                history.push('/assessment/not-found')
              } else {
                //create newUserAssessment
                const newUserAssessment = initializeNewUserAssessment(assessmentId, sets, items, docId, user, schoolYear)
                const userAssessmentId = keys(newUserAssessment)[0]

                // update userAssessment and user with the data in a batch update
                const batch = db.batch()
                const userRef = db.collection('students').doc(docId)
                const userAssessmentRef = db.collection('userAssessments').doc(userAssessmentId)
                
                let migrateAssessmentId = false
                // Update the user with info on the new userAssessment
                // add the new assessment by year to current assessment map in db
                if (user.assessments[assessmentId]) {
                  //migration : migrates current userAssessment id to sy2018
                  migrateAssessmentId = user.assessments[assessmentId].userAssessmentId;

                  if(migrateAssessmentId){
                    batch.update(
                      userRef,
                      {
                        'assessments': {
                          [assessmentId]: {
                            //previous db structure for userAssessment is also there,
                            //other devs have no issues.
                            assessmentId,
                            userAssessmentId: migrateAssessmentId,
                            //
                           [schoolYear]: {
                            assessmentId,
                            userAssessmentId: migrateAssessmentId
                           }
                          }
                        }
                      })
                  } else {
                    //insert new assessment with the new school year
                    batch.update(
                      userRef,
                      {
                        'assessments': {
                          ...user.assessments,
                          [assessmentId]: {
                            ...user.assessments[assessmentId],
                           [schoolYear]: {
                            assessmentId,
                            userAssessmentId
                           }
                          }
                        }
                      })
                  }
                  
                //if assessment map is empty, initialze it with 
                //new assessment by year in db
                } else if(user.assessments) {
                  batch.update(
                    userRef,
                    {
                      'assessments': {
                        ...user.assessments,
                        [assessmentId]: {
                         [schoolYear]: {
                          assessmentId,
                          userAssessmentId
                         }
                        }
                      }
                    })
                } else {
                  batch.set(
                    userRef,
                    {
                      'assessments': {
                        [assessmentId]: {
                          [schoolYear]: {
                            assessmentId,
                            userAssessmentId
                           }
                        }
                      }
                    },
                    {merge: true}
                  )
                }

                // store the new userAssessment in the db
                batch.set(userAssessmentRef, newUserAssessment[userAssessmentId])

                batch.commit()
                  .then( () => {
                    //update the indicator selector component with newly added assessment
                    let currentYear = Number(schoolYear.split('sy')[1])
                    let nextYear = currentYear + 1
                    
                    let option;
                    
                    if(migrateAssessmentId){
                      //update the current state of assessment
                        db.collection('userAssessments').doc(migrateAssessmentId).get()
                        .then((userAssessmentDoc) => {
                          const userAssessment = userAssessmentDoc.data()

                          success(userAssessment)
                          initSelector(docId)

                        }).catch((err) => error(err))
                    }else {
                      userAssessmentRef.get()
                      .then((userAssessmentDoc) =>{
                        const userAssessment = userAssessmentDoc.data()
                      })
                      //else proceed with the new assessment
                      initSelector(docId)
                      success(newUserAssessment[userAssessmentId])
                    }
                   
                    
                  })
                  .catch( (err) => error(err))
              }
            })
            .catch( (err) => error(err))
        }
      }
      
      }).catch((err) => error(err))

  }

  if (role !== 'Student') {
    return getGroupUA(user, assessmentId, studentId, districts)
  }

  function initSelector (docId, user) {
    if(user) {
      initTestSelector(null, user)
    } else {
      db.collection('students').doc(docId).get()
      .then((student) => {
      initTestSelector(null, student.data())
    })
    }
    
  }

}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/initializeAssessment.js